<template>
    <div>
        <PayerInformation />
        <PayerComments class="mt-2" />
        <!-- <AdditionalUBLocators class="mt-2" /> -->
        <AdditionalBillingInfo class="mt-2" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import PayerInformation from "./PayerInformation/PayerInformation.vue";
import PayerComments from "./PayerComments/PayerComments.vue";
import AdditionalUBLocators from "./AdditionalUBLocators/AdditionalUBLocators.vue";
import AdditionalBillingInfo from "./AdditionalBillingInfo/AdditionalBillingInfo.vue";

export default defineComponent({
    components: {
        PayerInformation,
        PayerComments,
        AdditionalUBLocators,
        AdditionalBillingInfo
    }
});
</script>
